var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('b-col',{attrs:{"md":"5"}},[_c('LoginWindow')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }